class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.mainDetailsToggle.querySelector("summary");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener(
      "toggle",
      this.onToggle.bind(this)
    );

    this.syncAriaExpanded();
  }

  onToggle() {
    this.syncAriaExpanded();
  }

  syncAriaExpanded() {
    const isOpen = this.mainDetailsToggle.hasAttribute("open");
    if (this.summary) {
      this.summary.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class MegaMenuItem extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector(".mega-menu-toggle");
    this.container = this.querySelector(".mega-menu-item-container");
    this.items = this.querySelectorAll(".mega-menu-sub a");
    this._isOpen = false;

    if (this.trigger && !this.trigger.hasAttribute("aria-expanded")) {
      this.trigger.setAttribute("aria-expanded", "false");
    }
    if (this.container) {
      this.container.setAttribute("inert", "");
      this.container.setAttribute("hidden", "");
    }

    this.items.forEach(function (item) {
      item.addEventListener("mouseover", this.mouseOver.bind(this));
    }.bind(this));

    this.rightItems = this.querySelectorAll(
      ".mega-menu-right .mega-menu-grandchilds:first-child"
    );
    this.rightItems.forEach(function (item) {
      item.classList.add("active");
    });

    if (this.trigger) {
      this.trigger.addEventListener("click", this.onTriggerClick.bind(this));
      this.trigger.addEventListener("keydown", this.onTriggerKeyDown.bind(this));
    }
    this.container &&
      this.container.addEventListener("keydown", this.onPanelKeyDown.bind(this));

    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
  }

  getMenuItems() {
    if (!this.container) return [];
    return Array.from(this.container.querySelectorAll(".mega-menu-sub a, .link-to-all-link"));
  }

  closeSiblingMenus() {
    var nav = this.closest(".header__inline-menu");
    if (!nav) return;
    nav.querySelectorAll("mega-menu-item").forEach(function (el) {
      if (el !== this && typeof el.close === "function") el.close();
    }.bind(this));
  }

  open() {
    if (this._isOpen) return;
    this.closeSiblingMenus();
    this._isOpen = true;
    this.classList.add("is-open");
    if (this.container) {
      this.container.removeAttribute("inert");
      this.container.removeAttribute("hidden");
    }
    if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
  }

  close() {
    if (!this._isOpen) return;
    this._isOpen = false;
    this.classList.remove("is-open");
    if (this.container) {
      this.container.setAttribute("inert", "");
      this.container.setAttribute("hidden", "");
    }
    if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
  }

  toggle() {
    if (this._isOpen) this.close();
    else this.open();
  }

  onTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggle();
  }

  onTriggerKeyDown(event) {
    if (event.code !== "Enter" && event.code !== "Space") return;
    event.preventDefault();
    if (this._isOpen) {
      this.close();
    } else {
      this.open();
      this.focusFirstMenuItem();
    }
  }

  focusFirstMenuItem() {
    var self = this;
    requestAnimationFrame(function () {
      var items = self.getMenuItems();
      if (items.length) items[0].focus();
    });
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    var self = this;
    setTimeout(function () {
      if (!self.contains(document.activeElement)) self.close();
    }, 0);
  }

  onFocusOut(event) {
    var self = this;
    var related = event.relatedTarget;
    if (related && self.contains(related)) return;
    setTimeout(function () {
      if (!self.contains(document.activeElement)) self.close();
    }, 0);
  }

  onPanelKeyDown(event) {
    if (!this._isOpen) return;

    var items = this.getMenuItems();
    if (!items.length) return;

    var idx = items.indexOf(document.activeElement);
    var inPanel = idx !== -1;

    switch (event.code) {
      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        this.close();
        if (this.trigger) this.trigger.focus();
        break;

      case "Tab":
        if (!inPanel) return;
        if (event.shiftKey && idx === 0) {
          // Shift+Tab from the first item: close and return focus to the toggle.
          event.preventDefault();
          if (this.trigger) this.trigger.focus();
          this.close();
        }
        // Forward Tab from the last item: let focus move naturally to the
        // next top-level option; onFocusOut then closes the fly-out.
        break;

      case "ArrowDown":
        if (!inPanel) return;
        event.preventDefault();
        items[(idx + 1) % items.length].focus();
        break;

      case "ArrowUp":
        if (!inPanel) return;
        event.preventDefault();
        items[(idx - 1 + items.length) % items.length].focus();
        break;

      case "Home":
        if (!inPanel) return;
        event.preventDefault();
        items[0].focus();
        break;

      case "End":
        if (!inPanel) return;
        event.preventDefault();
        items[items.length - 1].focus();
        break;
    }
  }

  mouseOver(event) {
    var grandchilds = event.currentTarget
      .closest(".mega-menu-item-container")
      .querySelectorAll(".mega-menu-grandchilds");

    grandchilds.forEach(function (item) {
      if (
        item.dataset.megaSubHandle == event.currentTarget.dataset.megaHandle
      ) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }
}

customElements.define("mega-menu-item", MegaMenuItem);
